export default function initFooterAccordion() {
    const triggers = document.querySelectorAll('.js-footer-trigger');

    if (triggers.length === 0) return;

    triggers.forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            // Previne comportamento padrão, por segurança
            e.preventDefault();

            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const contentId = this.getAttribute('aria-controls');
            const content = document.getElementById(contentId);

            if (!content) return;

            if (isExpanded) {
                // Fecha
                this.setAttribute('aria-expanded', 'false');
                content.classList.remove('is-open');
            } else {
                // Abre
                this.setAttribute('aria-expanded', 'true');
                content.classList.add('is-open');
            }
        });
    });
}